export const ImportTypes = {
  HR: 'hr',
  CONTRIBUTION: 'contribution',
  BROKER: 'broker',
};
